import { Drawer, Flex, Modal } from 'antd';
import Title from 'antd/es/typography/Title';
import ButtonIcon from '../buttonIcon/ButtonIcon';
import classes from './SideDrawer.module.scss';
import { useMedia } from '../../../hooks/useMediaQuery';
import { fontSize, colors, spacing } from '../../../theming';
import { useTranslation } from 'react-i18next';
import icon from '../../styles/Icon.module.scss';

export default function SideDrawer({ title, open, closeDrawer, children, width, padding, hasUnsavedChanges = false }) {
    const { isSmallDevice } = useMedia();
    const { t } = useTranslation(['confirmModal']);

    const handleClose = () => {
        if (!hasUnsavedChanges) {
            closeDrawer();
            return;
        }

        Modal.confirm({
            title: (
                <Flex gap={spacing[1]} align="center" style={{ width: 'fit-content' }}>
                    <i className={`fi fi-rr-triangle-warning ${icon.md}`} style={{ color: colors.colorWarning }} />
                    {t('unsaved-changes.title')}
                </Flex>
            ),
            content: t('unsaved-changes.message'),
            icon: null,
            width: 'fit-content',
            styles: { body: { padding: spacing[4] } },
            okText: t('buttons.exit'),
            okButtonProps: { danger: true },
            cancelText: t('buttons.cancel'),
            onOk: closeDrawer,
            centered: true,
        });
    };

    return (
        <Drawer
            width={isSmallDevice ? '100%' : width ? width : '555px'}
            onClose={handleClose}
            closable={false}
            open={open}
            styles={{
                body: {
                    padding: isSmallDevice ? spacing[4] : padding ? padding : spacing[8],
                    position: 'relative',
                },
                content: {
                    borderRadius: '20px 0 0 20px',
                },
            }}
        >
            <Flex vertical>
                <ButtonIcon
                    onClick={handleClose}
                    icon="fi-rr-cross"
                    style={{ position: isSmallDevice && 'static', placeSelf: 'end' }}
                />
                {title && (
                    <Title
                        className={classes.title}
                        style={{ fontSize: isSmallDevice && fontSize.H4, marginBottom: spacing[5] }}
                    >
                        {title}
                    </Title>
                )}
                {children}
            </Flex>
        </Drawer>
    );
}
